import { createFileRoute, redirect } from "@tanstack/react-router";
import { notifyError } from "@theprelude/ds";
import { z } from "zod";
import { overlaySchema } from "@/components/overlays";

const indexSchema = z.object({
  issuer: z.string().optional().catch(undefined),
  token: z.string().optional().catch(undefined),
  overlay: overlaySchema,
  error_description: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/")({
  validateSearch: indexSchema,
  beforeLoad: async ({ search }) => {
    if (search.error_description) {
      notifyError({
        message: search.error_description.replaceAll("+", " "),
      });
    }

    throw redirect({
      to: "/home",
    });
  },
});
